import { cancelable } from 'cancelable-promise';
import { PromiseHelper } from '../../helpers/PromiseHelper';
export class ImagePresentationRenderer {
    constructor(assetViewerView, presentation) {
        this.assetViewerView = assetViewerView;
        this.presentation = presentation;
        this.container = null;
        this.image = null;
        this.loadPromise = null;
        this.isLoading = false;
        this.isActive = false;
    }
    get dimensions() {
        return this.width && this.height ? { width: this.width, height: this.height } : null;
    }
    get width() {
        if (this._width) {
            return this._width;
        }
        const presentation = [this.presentation].find(presentation => !!(presentation && presentation.details && presentation.details.dimensions && presentation.details.dimensions.width));
        if (presentation) {
            const exceptions = presentation.details.dimensions.exceptions;
            return exceptions && exceptions[this.assetViewerView.page]
                ? exceptions[this.assetViewerView.page].width
                : presentation.details.dimensions.width;
        }
    }
    get height() {
        if (this._height) {
            return this._height;
        }
        const presentation = [this.presentation].find(presentation => !!(presentation && presentation.details && presentation.details.dimensions && presentation.details.dimensions.height));
        if (presentation) {
            const exceptions = presentation.details.dimensions.exceptions;
            return exceptions && exceptions[this.assetViewerView.page]
                ? exceptions[this.assetViewerView.page].height
                : presentation.details.dimensions.height;
        }
    }
    set width(value) {
        this._width = value;
    }
    set height(value) {
        this._height = value;
    }
    get hasMetaData() {
        // TODO save original dimensions in this instance?
        return this.image ? true : false;
    }
    get url() {
        const pageIndex = (this.presentation.details && this.presentation.details.firstPageIndex) || 0;
        return this.presentation.urls[pageIndex] || this.assetViewerView.assetViewerItem.downloadUrl;
    }
    load() {
        this.isLoading = true;
        const defer = PromiseHelper.defer();
        this.loadPromise = defer.promise;
        const image = (this.image = new Image());
        image.src = this.url;
        image.onload = onLoad.bind(this);
        image.onerror = onError.bind(this);
        if (this.assetViewerView.assetViewerItem.isDownloadable === false) {
            this.image.addEventListener('contextmenu', e => e.preventDefault());
        }
        return defer.promise;
        function onLoad() {
            this.isLoading = false;
            if (image.width && image.height) {
                this.width = image.naturalWidth;
                this.height = image.naturalHeight;
                defer.resolve({
                    width: this.width,
                    height: this.height
                });
            }
            else {
                this.isLoading = false;
                defer.reject();
            }
            image.onload = null;
            image.onerror = null;
        }
        function onError(error) {
            this.isLoading = false;
            image.onload = null;
            image.onerror = null;
            this.image = null;
            defer.reject(error);
        }
    }
    render(container) {
        // const loadPromise = this.loadPromise || this.load()
        this.container = container;
        return cancelable(Promise.resolve().then(() => {
            this.image.style.width = '100%';
            this.image.style.height = '100%';
            container.appendChild(this.image);
        }));
    }
    destroy() {
        if (this.container) {
            this.container.innerHTML = '';
            this.container = null;
        }
        this.image = null;
    }
    destroyFinal() {
        this.destroy();
    }
}
//# sourceMappingURL=ImagePresentationRenderer.js.map